import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';
import type { AddPermitTypeFormInputs } from '@src/permitTypesManager/AddPermitTypeFormInputs';
import {
  IsUsedMobileHomeField,
  LoadIsMobileHomeField,
  MobileHomeBoxLengthField,
  MobileHomeBoxWidthField,
  MobileHomeCurbsideEavesLengthField,
  MobileHomeEaveWidthField,
  MobileHomeHitchLengthField,
  MobileHomeHudNumberField,
  MobileHomeMakeField,
  MobileHomeRoadsideEavesLengthField,
  MobileHomeSerialNumberField,
  MobileHomeYearField,
} from '@src/permitTypesManager/permitTypeSections/MobileHomeFields';
import type { SectionField } from '@src/permitTypesManager/permitTypeSections/PermitTypeSectionCheboxList';
import { PermitTypeSectionCheckboxList } from '@src/permitTypesManager/permitTypeSections/PermitTypeSectionCheboxList';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const MobileHomeSection = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<AddPermitTypeFormInputs>();

  const fields: SectionField[] = [
    {
      field: LoadIsMobileHomeField,
      label: t('fields.loadIsMobileHome'),
    },
    {
      field: IsUsedMobileHomeField,
      label: t('fields.isUsedMobileHome'),
    },
    {
      field: MobileHomeYearField,
      label: t('fields.mobileHomeYear'),
    },
    {
      field: MobileHomeMakeField,
      label: t('fields.mobileHomeMake'),
    },
    {
      field: MobileHomeSerialNumberField,
      label: t('fields.mobileHomeSerialNumber'),
    },
    {
      field: MobileHomeHitchLengthField,
      label: t('fields.mobileHomeHitchLength'),
    },
    {
      field: MobileHomeEaveWidthField,
      label: t('fields.mobileHomeEaveWidth'),
    },
    {
      field: MobileHomeBoxWidthField,
      label: t('fields.mobileHomeBoxWidth'),
    },
    {
      field: MobileHomeBoxLengthField,
      label: t('fields.mobileHomeBoxLength'),
    },
    {
      field: MobileHomeRoadsideEavesLengthField,
      label: t('fields.mobileHomeRoadsideEavesLength'),
    },
    {
      field: MobileHomeCurbsideEavesLengthField,
      label: t('fields.mobileHomeCurbsideEavesLength'),
    },
    {
      field: MobileHomeHudNumberField,
      label: t('fields.mobileHomeHudNumber'),
    },
  ];
  return (
    <Stack direction="column" gap={theme.spacing['1']}>
      <PermitTypeSectionCheckboxList sectionFields={fields} control={control} />
    </Stack>
  );
};
